import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class VerificationConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isPhoneVerificationEnabled(): boolean {
		return this.configService.get((x) => x.commonUi.verification.isPhoneVerificationEnabled, false);
	}

	kycBackButtonDisabledMarkets() {
		return this.configService.get((x) => x.commonUi.verification.kycBackButtonDisabledMarkets, []);
	}
}
